import request from '@/utils/request'

//全部订单列表
export function fetchList(params) {
  return request({
    url:'/kxorders/newOrder/list',
    method:'get',
    params:params
  })
}


//未付款订单列表
export function nopayorder(params) {
  return request({
    url:'/kxorders/userOrder/list',
    method:'get',
    params:params
  })
}


//待发货订单列表
export function deliverorder(params) {
  return request({
    url:'/kxorders/userOrder/list',
    method:'get',
    params:params
  })
}

//已取消订单列表
export function cancelOrderList(params) {
  return request({
    url:'/kxorders/newOrder/getCancelledOrder',
    method:'get',
    params:params
  })
}



//已付款未发货取消订单 仓库审核列表type:0,财务审核列表type:1
export function getCancelledOrder(params) {
  return request({
    url:'/kxorders/newOrder/getCancelledOrder',
    method:'get',
    params:params
  })
}



// //已付款未发货取消订单 财务审核列表
// export function getWarehouseApprovalOrder(params) {
//   return request({
//     url:'/kxorders/newOrder/getWarehouseApprovalOrder',
//     method:'get',
//     params:params
//   })
// }



//修改价格订单列表
export function ChangeOrderPriceList(params) {
  return request({
    url:'/kxorders/newOrder/getChangeOrderPriceList',
    method:'get',
    params:params
  })
}


//审核修改价格订单
export function checkUpdateOrderLogById(id) {
  return request({
    url:'/kxorders/newOrder/checkUpdateOrderLogById/'+id,
    method:'put',
  });
}


//关闭订单
export function closeOrder(params) {
  return request({
    url:'/kxorders/order/update/close',
    method:'post',
    params:params
  })
}

//删除订单
export function deleteOrder(params) {
  return request({
    url:'/kxorders/order/delete',
    method:'post',
    params:params
  })
}


// export function deliveryOrder(data) {
//   return request({
//     url:'/kxorders/order/update/delivery',
//     method:'post',
//     data:data
//   });
// }

// export function getOrderDetail(id) {
//   return request({
//     url:'/order/'+id,
//     method:'get'
//   });
// }

//订单详情
export function getOrderDetail(id,params) {
  return request({
    url:'/kxorders/newOrder/queryOrderDetailByOrderId/'+id,
    method:'get',
    params:params
  });
}

//修改收货地址
export function updateReceiverInfo(id,data) {
  return request({
    url:'/kxorders/newOrder/updateAddressByOrderId/'+id,
    method:'put',
    data:data
  });
}

//修改订单总金额
export function updateMoneyInfo(id,data) {
  return request({
    url:'/kxorders/newOrder/updateOrderMoneyById/'+id,
    method:'put',
    data:data
  });
}

//修改商品明细数量金额
export function updateOrderDetialMoneyById(id,data) {
  return request({
    url:'/kxorders/newOrder/updateOrderDetailMoneyById/'+id,
    method:'put',
    data:data
  });
}

//订单备注
export function updateOrderNote(data) {
  return request({
    url:'/kxorders/newOrder/editOrderRemark',
    method:'put',
    data:data
  })
}

//订单绑定客服
export function orderbdkf(data) {
  return request({
    url: '/kxorders/newOrder/bindCustomerServiceToHistoryOrders',
    method: 'put',
    data: data
  })
}


//订单发货
export function updateOrderLogisticsState(id,data) {
  return request({
    url:'/kxorders/newOrder/updateOrderLogisticsState/'+id,
    method:'put',
    data:data
  });
}


//订单发货选择物流
export function listExpress(params) {
  return request({
    url:'/kxorders/adminSmallFunctions/listExpress',
    method:'get',
    params:params
  })
}


//取消订单
export function cancelOrdersByOrderId(id) {
  return request({
    url:'/kxorders/newOrder/cancelOrdersByOrderId/'+id,
    method:'put',
  });
}


//客服审核取消订单
export function customerServiceAuditCancelOrdersByOrderId(data) {
  return request({
    url:'/kxorders/newOrder/customerServiceAuditCancelOrdersByOrderId/',
    method:'put',
    data:data
  });
}

//仓库审核取消订单
export function warehouseAuditCancelOrdersByOrderId(data) {
  return request({
    url:'/kxorders/newOrder/warehouseAuditCancelOrdersByOrderId/',
    method:'put',
    data:data
  });
}


//财务审核取消订单
export function financeAuditCancelOrdersByOrderId(data) {
  return request({
    url:'/kxorders/newOrder/financeAuditCancelOrdersByOrderId/',
    method:'put',
    data:data
  });
}



//根据订单号修改商品数量
// export function cancelOrdersByOrderDetailId(data) {
//   return request({
//     url:'/kxorders/newOrder/cancelOrdersByOrderDetailId',
//     method:'post',
//     data:data
//   });
// }

//根据订单号取消商品
export function cancelOrdersByOrderDetailId(data) {
  return request({
    url:'/kxorders/userOrder/cancelOrdersByOrderIdToUser/',
    method:'put',
    data:data
  });
}



//获取取消商品原因
export function BasedictType(id) {
  return request({
    url:'/kxorders/newOrder/getBasedictType/'+id,
    method:'get',
  })
}

//获取退货单
export function getOrderReturnApplyByOrderId(orderId) {
  return request({
    url:'/kxorders/newOrder/getOrderReturnApplyByOrderId/'+orderId,
    method:'get',
  })
}



//当前商品明细明细
export function getWillCancelOrderDetailByOrderId(id) {
  return request({
    url:'/kxorders/newOrder/getWillCancelOrderDetailByOrderId/'+id,
    method:'get'
  });
}

//线下转账审核列表
export function getOfflineTransferOrder(params) {
  return request({
    url:'/kxorders/newOrder/getOfflineTransferOrder',
    method:'get',
    params:params
  })
}


//财务审核转账
export function reviewOfflineTransferOrders(data) {
  return request({
    url:'/kxorders/newOrder/reviewOfflineTransferOrders/',
    method:'post',
    data:data
  });
}


//仓库,财务审核已付款未发货订单
export function reviewCancellationOrder(data) {
  return request({
    url:'/kxorders/newOrder/reviewCancellationOrder',
    method:'put',
    data:data
  });
}


//供应商订单列表
export function getPickOrder(params) {
  return request({
    url:'/kxorders/userOrder/getPickOrder',
    method:'get',
    params:params
  })
}


//当前供应商订单下商品明细
export function queryjhmx(id) {
  return request({
    url:'/kxorders/userOrder/queryjhmx/'+id,
    method:'get'
  });
}


//保存拣货明细
export function savePickGoodsInfo(data) {
  return request({
    url:'/kxorders/userOrder/savePickGoodsInfo/',
    method:'post',
    data:data
  });
}


//供应商订单详情
export function getOrderDetailInfo(id) {
  return request({
    url:'/kxorders/userOrder/getOrderDetailInfo/'+id,
    method:'get'
  });
}


//已付款全部取消订单
export function cancelBeforeReview(data) {
  return request({
    url:'/kxorders/userOrder/cancelBeforeReview/',
    method:'put',
    data:data
  });
}



//导出订单到到excel
export function exportorders(data) {
  return request({
    url:'/kxorders/newOrder/outTest/',
    method:'post',
    data:data
  });
}



//打印订单
export function printorders(params) {
  return request({
    url:'/kxorders/newOrder/printOrder/',
    method:'get',
    params:params
  });
}


//当前订单当前商品拣货明细
export function refreshJhmx(id) {
  return request({
    url:'/kxorders/userOrder/refreshJhmx/'+id,
    method:'get'
  });
}



//导出订单明细
export function exportOrder(data) {
  return request({
    url:'/kxorders/newOrder/exportOrder/',
    method:'get',
    data:data,
  });
}


//导入物流 物流列表
export function getExpressList(params) {
  return request({
    url:'/kxorders/newOrder/getExpressList',
    method:'get',
    params:params
  })
}

//导入物流
export function ImportExpress(data) {
  return request({
    url: '/kxorders/newOrder/importEventData',
    method: 'post',
    data: data,
    headers: {
      "Content-Type": "multipart/form-data;charset=utf-8"
    },
  })
}

//财务审核退货订单并退款
export function refundsOrders(data) {
  return request({
    url: '/kxorders/newOrder/refunds',
    method: 'post',
    data: data,
  })
}

//上传转账凭证
export function uploadPayImg(data) {
  return request({
    url: '/kxuser/user/uploadUserAvatar/payImg',
    method: 'post',
    data: data,
    headers: {
      "Content-Type": "multipart/form-data;charset=utf-8"
    },
  })
}


//保存转账凭证
export function paymentVoucher(data) {
  return request({
    url: '/kxorders/newOrder/paymentVoucher/',
    method: 'post',
    data: data
  })
}


//手动标号
export function manualLabeling(data) {
  return request({
    url: '/kxorders/newOrder/manualLabeling/',
    method: 'post',
    data: data
  })
}

//快递跟踪
export function ExpOrder(id,params) {
  return request({
    url: 'kxorders/userOrder/wlcx/' +id,
    method: 'get',
    params: params
  })
}


//查看发票
export function invoiceDownload(params) {
  return request({
    url: 'kxorders/userOrder/invoiceDownload',
    method: 'get',
    params: params
  })
}

//下载发票
export function invoiceDL(params) {
  return request({
    url: 'kxorders/userOrder/invoiceDL',
    method: 'get',
    params: params
  })
}


//申请发票
export function invoiceRequest(data) {
  return request({
    url: 'kxorders/userOrder/invoiceRequest',
    method: 'post',
    data: data
  })
}


//无单位订单绑定单位
export function addManualOdrCompany(params) {
  return request({
    url: 'kxorders/userOrder/addManualOdrCompany',
    method: 'get',
    params: params
  })
}


//修改收货地址配送方式备注
export function updateOrderInfo(data) {
  return request({
    url: 'kxorders/newOrder/updateOrderInfo',
    method: 'post',
    data: data
  })
}


//当前用户余额
export function getCompanyMoney(id,params) {
  return request({
    url:'/kxuser/bankAccount/queryVirtualMoneyByCompanyId2/'+id,
    method:'get',
    params:params
  })
}


//线下转账
export function transferAccounts(data) {
  return request({
    url: 'kxorders/oderPayment/transferAccounts.do/',
    method: 'post',
    data: data
  })
}



//手动回调微信支付结果
export function getWeChatCallbackQuery(data) {
  return request({
    url:'/kxorders/newOrder/weChatCallbackQuery',
    method:'post',
    data:data
  })
}




//注册批件下载
export function downzcyj(data) {
  return request({
    url:'/kxorders/userOrder/zcyj',
    method:'post',
    data:data
  })
}
export function homeIsPack(params) {
  return request({
    url:'/kxorders/userOrder/isPack',
    method:'get',
    params:params
  })
}


//订单默认查询天数
export function querySconfigInfo(id,params) {
  return request({
    url:'/kxuser/sconfigInfo/querySconfigInfo/'+id,
    method:'get',
    params:params
  })
}


//订单修改业务员
export function updateOrdersSalerInfo(data) {
  return request({
    url:'/kxorders/newOrder/updateOrdersSalerInfo',
    method:'put',
    data:data
  })
}

//根据订单id修改挂账订单运费
export function updateOrderPostage(data) {
  return request({
    url:'/kxorders/newOrder/updateOrderPostage',
    method:'put',
    data:data
  })
}


//订单明细改价审核
export function queryZlwhApplyOrderDetailInfoList(params) {
  return request({
    url:'/kxorders/newOrder/queryZlwhApplyOrderDetailInfoList',
    method:'get',
    params:params
  })
}


//订单总价修改审核明细列表
export function getZlwhApplyOrderDetailTotalInfoList(params) {
  return request({
    url:'/kxorders/newOrder/getZlwhApplyOrderDetailTotalInfoList',
    method:'get',
    params:params
  })
}


//订单总价修改审核明细详情
export function queryZlwhApplyOrdersInfoList(params) {
  return request({
    url:'/kxorders/newOrder/queryZlwhApplyOrdersInfoList',
    method:'get',
    params:params
  })
}


//财务审核改价订单
export function auditChangeOrdersInfo(data) {
  return request({
    url:'/kxorders/newOrder/auditChangeOrdersInfo',
    method:'put',
    data:data
  })
}

//订单复购
export function repurchaseOrderById(id,data) {
  return request({
    url:'/kxorders/newOrder/repurchaseOrderById/'+id,
    method:'post',
    data:data
  })
}

//再次购买
export function joinAgain(id, params){
  return request({
    url: '/kxshopcar/shopCar/joinAgain/' + id,
    method: 'get',
    params:params
  })
}

//图片上传  接口最后test是文件夹名称
export function uploadimgFront(data) {
  return request({
    url: '/kxuser/user/uploadUserAvatar/orderexpress',
    method: 'post',
    data: data,
    headers: {
      "Content-Type": "multipart/form-data;charset=utf-8"
    },
  })
}

//获取物流凭证等信息
export function getLogisticsInfoByOrderId(id){
  return request({
    url: '/kxorders/newOrder/getLogisticsInfoByOrderId/' + id,
    method: 'get'
  })
}

//删除物流凭证
export function deleteAttachment(id){
  return request({
    url: '/kxuser/common/deleteAttachmentInfo/' + id,
    method: 'put'
  })
}

//设置订单是否需要企业资质
export function setCertificate(id,params){
  return request({
    url:'kxorders/adminSmallFunctions/setCertificate/' + id,
    method: 'put',
    params:params
  })
}

//延长时间设置
export function setOrderTermValidity(id,params){
  return request({
    url:'kxorders/adminSmallFunctions/setOrderTermValidity/' + id,
    method: 'put',
    params:params
  })
}

//生成聚合支付二维码
export function homePayOrder(data){
  return request({
    url:'kxorders/oderPayment/bankGroupScanCode',
    method: 'post',
    data:data
  })
}

//余额支付
export function balancePayment(data){
  return request({
    url:'kxorders/oderPayment/balancePayment/',
    method: 'post',
    data:data
  })
}

//查询取消进度
export function getCancelProgress(id) {
  return request({
    url:'/kxorders/checkOrders/getCancelProgress/'+id,
    method:'get'
  })
}

//新增物流黑名单
export function insertCustomerExpress(data) {
  return request({
    url:'/kxorders/adminSmallFunctions/insertCustomerExpress',
    method:'post',
    data:data
  })
}

//修改物流黑名单
export function updateCustomerExpressById(data) {
  return request({
    url:'/kxorders/adminSmallFunctions/updateCustomerExpressById',
    method:'put',
    data:data
  })
}

//删除物流黑名单
export function deletecustomerExpressById(ids) {
  return request({
    url:'/kxorders/adminSmallFunctions/deleteCustomerExpressById/'+ids,
    method:'delete',
  })
}

//获取物流黑名单列表
export function getLogisticsBlackList(params) {
  return request({
    url:'/kxorders/adminSmallFunctions/getLogisticsBlackList',
    method:'get',
    params:params
  })
}


export function getAccompanyingDocumentsDetails(params) {
  return request({
    url:'/kxorders/userOrder/getAccompanyingDocumentsDetails',
    method:'get',
    params:params
  })
}

//获取拣货单
export function getPickingInfo(params) {
  return request({
    url:'/kxorders/orderPick/getPickingInfo',
    method:'get',
    params:params
  })
}

//修改订单排序
export function updateOrderSort(data) {
  return request({
    url:'/kxorders/orderPick/updateOrderSort',
    method:'put',
    data:data
 })
}

export function getSendCount(params) {
  return request({
    url:'/kxorders/newOrder/getSendCount',
    method:'get',
    params:params
  })
}

//物流调整
export function changeExpressByOrderId(id, data) {
  return request({
    url:'/kxorders/adminSmallFunctions/changeExpressByOrderId/'+ id,
    method:'put',
    data:data
 })
}

// 查询全部结算单
export function queryAll(params) {
  return request({
    url:'kxorders/adminSmallFunctions/queryAll',
    method:'get',
    params:params
  })
}

// 根据结算单，查询对应订单信息
export function queryDetailByOrderNumber(orderNumber, params) {
  return request({
    url:'kxorders/adminSmallFunctions/queryDetailByOrderNumber/'+ orderNumber,
    method:'get',
    params:params
  })
}


//更新结算单状态
export function updateSettlementOrderStatus(orderNumber, data) {
  return request({
    url:'kxorders/adminSmallFunctions/updateSettlementOrderStatus/'+ orderNumber,
    method:'put',
    data:data
 })
}

//添加结算单据编号
export function insertSettlementNumber(data) {
  return request({
    url:'kxorders/adminSmallFunctions/insertSettlementNumber',
    method:'post',
    data:data
 })
}









// WEBPACK FOOTER //
// ./src/api/order.js